// where a notification takes the user when clicked
export const NOTIFICATION_ROUTES: { [type: string]: string } = {
  company: 'companies',
  sync: 'companies',
  bill: 'bills',
  billPayment: 'bill-payments',
  invoice: 'invoices',
  payment: 'payments',
  customer: 'customers',
  vendor: 'vendors',
  service: 'services',
};
